export const isSafeRedirectPath = (path: string | undefined): path is string =>
  typeof path === 'string' && /^\/(?!\/|\\)/.test(path)
